var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns"},[(_vm.schedule)?_c('div',{staticClass:"column is-one-third"},[_c('schedule-card',{attrs:{"schedule":_vm.schedule}})],1):_vm._e()]),_c('router-view',{staticClass:"body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }